var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-buy-table-pane" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "请输入活动名称", clearable: "" },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.search },
            },
            [_vm._v("\n      搜索\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleAdd },
            },
            [_vm._v("\n      新增拼单活动\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "拼单活动ID",
              prop: "fnId",
              align: "center",
              width: "180",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动名称",
              prop: "activityName",
              align: "center",
              width: "180",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "拼单商品",
              prop: "goodsName",
              align: "left",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.goodsNameList, function (item, idx) {
                    return _c("div", { key: item }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(idx + 1) +
                          "." +
                          _vm._s(item) +
                          "\n        "
                      ),
                    ])
                  })
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动时间",
              prop: "activityTime",
              align: "left",
              width: "220",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "日期：" +
                          _vm._s(scope.row.startDateFormatter) +
                          " - " +
                          _vm._s(scope.row.endDateFormatter)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "时间：" +
                          _vm._s(scope.row.startTimeFormatter) +
                          " - " +
                          _vm._s(scope.row.endTimeFormatter)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "活动内容",
              prop: "personNum",
              align: "center",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.thresholdType === "quantity"
                      ? _c("span", [
                          _vm._v(
                            "\n          满" +
                              _vm._s(scope.row.threshold) +
                              "件, 每件减 " +
                              _vm._s(scope.row.discount) +
                              "元\n        "
                          ),
                        ])
                      : scope.row.thresholdType === "user"
                      ? _c("span", [
                          _vm._v(
                            "\n          满" +
                              _vm._s(scope.row.threshold) +
                              "人, 每人减 " +
                              _vm._s(scope.row.discount) +
                              "元\n        "
                          ),
                        ])
                      : scope.row.thresholdType === "amount"
                      ? _c("span", [
                          _vm._v(
                            "\n          满" +
                              _vm._s(scope.row.threshold) +
                              "元, 减 " +
                              _vm._s(scope.row.discount) +
                              "元\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "适用门店", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.storeScope === 0
                      ? _c(
                          "span",
                          [
                            _c("el-tag", [
                              _vm._v("\n            全部店铺\n          "),
                            ]),
                          ],
                          1
                        )
                      : scope.row.storeScope === 1
                      ? _c(
                          "span",
                          [
                            _vm._l(
                              (scope.row.storeNameList || []).slice(0, 3),
                              function (item) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item,
                                    staticStyle: { "margin-right": "3px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(item) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                            _vm._v(" "),
                            (scope.row.storeNameList || []).length > 3
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      placement: "top",
                                      "popper-class": "store-name-tooltip",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "max-width": "300px",
                                          "max-height": "200px",
                                          "overflow-y": "auto",
                                          "white-space": "normal",
                                          "word-break": "break-all",
                                          "line-height": "1.5",
                                        },
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              scope.row.storeNameList.join("、")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-tag",
                                      { staticStyle: { cursor: "pointer" } },
                                      [_vm._v("...")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "有效", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleEnable(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.markForEnable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "markForEnable", $$v)
                        },
                        expression: "scope.row.markForEnable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          编辑\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.listQuery.limit,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }